const __version__ ='dfat_v1.0'

module.exports = {
    __version__
}

